import { useCurrentUser } from 'client/components/auth/AuthModule';
import { Roles } from 'common/permissions/Roles';
import { useCallback } from 'react';
import { getNetworkErrorMessage } from '../network/errors/getNetworkErrorMessage';

export function useRoleNetworkErrorMessage() {
  const user = useCurrentUser();
  return useCallback(
    (error: any) => {
      if (user?.role === Roles.Admin.name) {
        return "Gli Amministratori non possono inviare domande. L'utilizzo del portale domande è solo a fini di anteprima quando si è autenticati come amministratore.";
      } else {
        return getNetworkErrorMessage(
          error,
          "Si è verificato un errore durante l'invio della domanda."
        );
      }
    },
    [user]
  );
}
